import * as React from 'react';

interface WalkthroughProps {
  current_step: number;
  total_steps: number;
  title: string | JSX.Element | JSX.Element[] | React.ReactNode;
  content: any;
  className?: string;
}

export const Walkthrough = ({ current_step, total_steps, title, content, className }: WalkthroughProps) => (
  <div className={className}>
    <div className="introjs__header">
      <span className="introjs__steps">{`Steps ${current_step}/${total_steps}`}</span>
    </div>
    <h3 className="introjs__title">{title}</h3>
    <div className="introjs__content">{content}</div>
  </div>
);
